import { CognitoError, isCognitoError } from "@domain/authentication/cognito/cognito-error";
import { CognitoUser } from "amazon-cognito-identity-js";

interface MultiInfraError {
	user: CognitoUser;
	error: unknown;
	infrastructureId: string;
}

interface MultiInfraCognitoError {
	user: CognitoUser;
	error: CognitoError;
	infrastructureId: string;
}

export function isMultiInfraCognitoError(error: MultiInfraError): error is MultiInfraCognitoError {
	return isCognitoError(error.error);
}
